import type { ArrowData, Cell } from './types';

export const ARROW_TIP_LENGTH = .38;
export const ARROW_HIT_RADIUS = .34;
const direction: Record<ArrowData['direction'], Cell> = {
  UP: { x: 0, y: -1 }, DOWN: { x: 0, y: 1 }, LEFT: { x: -1, y: 0 }, RIGHT: { x: 1, y: 0 }
};

function distanceToSegment(point: Cell, a: Cell, b: Cell): number {
  const dx = b.x - a.x, dy = b.y - a.y;
  const t = Math.max(0, Math.min(1, (dx * (point.x - a.x) + dy * (point.y - a.y)) / (dx * dx + dy * dy || 1)));
  return Math.hypot(point.x - a.x - t * dx, point.y - a.y - t * dy);
}

/** Include the visible tip, with the same touch padding as the arrow body. */
export function arrowHitDistance(point: Cell, arrow: ArrowData): number {
  const body = arrow.cells.map(cell => ({ x: cell.x + .5, y: cell.y + .5 }));
  const head = body.at(-1);
  if (!head) return Infinity;
  const dir = direction[arrow.direction];
  body.push({ x: head.x + dir.x * ARROW_TIP_LENGTH, y: head.y + dir.y * ARROW_TIP_LENGTH });
  let distance = Infinity;
  for (let i = 1; i < body.length; i++) distance = Math.min(distance, distanceToSegment(point, body[i - 1]!, body[i]!));
  return distance;
}
